export default __webpack_public_path__ + "static/0221-a1f4c0feb1dc37f81e383e10cb99c84c.png";